import { createSearchProps } from './search/search.props';
import { createItinerarySelectionProps } from './itinerarySelection/itinerarySelection.props';
import { createFilterProps } from './filter/filter.props';
export const createFlightResultsProps = ({
  search,
  filter,
  itinerarySelection
}) => ({
  ...createSearchProps(search),
  ...createFilterProps(filter),
  itinerarySelectionActions: createItinerarySelectionProps(itinerarySelection)
});